"use client";
import React from "react";

// const calculators = [
//   {
//     id: "01",
//     name: "ROC Fees Calculator",
//     link: "https://www.mca.gov.in/content/mca/global/en/mca/fo-llp-services/enquire-fees.html",
//   },
//   {
//     id: "02",
//     name: "Stamp Duty Calculator",
//     link: "https://leaveandlicense.igrmaharashtra.gov.in/Fees/calculator_sd",
//   },
//   {
//     id: "03",
//     name: "Income Tax Calculator",
//     link: "https://www.incometaxindia.gov.in/income-tax-calculator",
//   },
// ];

export default function CalculatorPage() {
    const calculators = [
        {
            id: "01",
            name: "ROC Fees Calculator",
            link: "https://www.mca.gov.in/content/mca/global/en/mca/fo-llp-services/enquire-fees.html",
        },
        {
            id: "02",
            name: "Stamp Duty Calculator",
            link: "https://leaveandlicense.igrmaharashtra.gov.in/Fees/calculator_sd",
        },
        {
            id: "03",
            name: "Income Tax Calculator",
            link: "https://www.incometaxindia.gov.in/income-tax-calculator",
        },
    ];

    return (
        <div className="calculator-wrapper" style={{ padding: "120px 70px" }}>
            <div className="calculator-header"
             style={{
                backgroundColor: "#eef2f6",
                padding: "20px 10px",
                borderRadius: "12px",
                textAlign: "center",
                marginBottom: "30px",
                border: "1px solid #d1d9e6",
                width: "100%"
            }}>
                <h2 style={{
                    margin: 0,
                    fontSize: "28px",
                    fontWeight: "700",
                    color: "#1a3c6e",
                    letterSpacing: "1px"
                }}>
                    CALCULATORS & TOOLS
                </h2>

                <p style={{
                    marginTop: "4px",
                    fontSize: "14px",
                    color: "#4b5563",
                    fontWeight: "500"
                }}>
                    Smart tools to assist in quick decision-making and compliance estimation:
                </p>
            </div>

            <div style={{
                overflowX: "auto",
                border: "1px solid #ddd",
                borderRadius: "6px"
            }}>
                <table style={{
                    width: "100%",
                    minWidth: "600px",
                    borderCollapse: "collapse"
                }}>
                    <thead style={{ backgroundColor: "#f5f5f5" }}>
                        <tr>
                            <th style={thStyle}>S. No.</th>
                            <th style={thStyle}>Tool Name</th>
                            <th style={thStyle}>Website</th>
                        </tr>
                    </thead>

                    <tbody>
                        {calculators.map((item) => (
                            <tr
                                key={item.id}
                                onMouseEnter={(e) => e.currentTarget.style.background = "#f9f9f9"}
                                onMouseLeave={(e) => e.currentTarget.style.background = "white"}
                            >
                                <td style={tdStyle}>{item.id}.</td>
                                <td style={tdStyle}>{item.name}</td>
                                <td style={{ ...tdStyle, wordBreak: "break-word" }}>
                                    <a
                                        href={item.link}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        style={{ color: "#1a73e8" }}
                                    >
                                        {item.link}
                                    </a>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        </div>
    );
}

const thStyle = {
    padding: "12px",
    textAlign: "left",
    border: "1px solid #ddd",
    fontWeight: "600"
};

const tdStyle = {
    padding: "12px",
    border: "1px solid #ddd",
};